import script from "./ThankYouPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ThankYouPage.vue?vue&type=script&setup=true&lang=js"

import "./ThankYouPage.vue?vue&type=style&index=0&id=2c753250&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c753250"]])

export default __exports__